import PropTypes from "prop-types";
import React from "react";
import { Spinner, NoResults } from "../../../";

const TableWrapper = ({ children, "aria-label": ariaLabel, role }) => (
  <div className="report-page__wrapper" role={role} aria-label={ariaLabel}>
    {children}
  </div>
);

TableWrapper.propTypes = {
  children: PropTypes.any,
  "aria-label": PropTypes.string,
  role: PropTypes.string,
};

const Content = (props) => {
  const { Table: TableComponent, isLoading, data = [] } = props;
  const hasData = data.length && data;

  const noResults = (
    <TableWrapper role="region" aria-label="Report results" aria-live="polite">
      <NoResults />
    </TableWrapper>
  );

  const loading = (
    <TableWrapper
      role="status"
      aria-label="Loading report data"
      aria-live="polite"
    >
      <Spinner className="report-page__spinner" aria-label="Loading spinner" />
    </TableWrapper>
  );

  const Table = () => (
    <div
      className="report-page--search"
      role="region"
      aria-label="Report data table"
      aria-live="polite"
    >
      {hasData ? TableComponent : noResults}
    </div>
  );

  return isLoading ? loading : <Table />;
};

Content.displayName = "Content";
Content.propTypes = {
  Table: PropTypes.any,
  isLoading: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.array),
  config: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object),
    cellOptions: PropTypes.object,
    headerOptions: PropTypes.object,
  }),
};

export default Content;
